import "./src/styles/global.css";
import emailjs from "@emailjs/browser";

// Must match the Public Key on https://dashboard.emailjs.com/admin/account
// (same account as your Email Service + Template). Update if you rotate keys.
const EMAILJS_PUBLIC_KEY = "DsWeIlaGUWjO8AFSt";
const GA_MEASUREMENT_ID = "G-8ZJQY8K4FT";

export const onClientEntry = () => {
  emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag === "function") {
    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    });
  }
};